<script>
  import AXHR from "../components/js/axhr.js";
  import Load from "./Load.svelte";
  import Modal from "./Modal.svelte";
  import { session } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });
  function checkSessionData(token, server) {
    if (token) {
      var config = {
        method: "get",
        url: sessions.api + "/rb",
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      AXHR(config).then(function (response) {
        let routeractive;
        let serverSelected = server;
        if (sessions.routeractive) {
          if (serverSelected) {
            if (response.data[serverSelected]) {
              routeractive = response.data[serverSelected];
            } else {
              routeractive = response.data[0];
              localStorage.setItem("_server_location", 0);
            }
          } else {
            if (sessions.routeractive.name === response.data[0].name) {
              routeractive = sessions.routeractive;
            } else {
              routeractive = response.data[0];
            }
          }
        } else {
          if (serverSelected) {
            if (response.data[serverSelected]) {
              routeractive = response.data[serverSelected];
            } else {
              routeractive = response.data[0];
              localStorage.setItem("_server_location", 0);
            }
          } else {
            console.log(response.data);
            routeractive = response.data[0];
          }
        }
        let sessionData = {
          api: sessions.api,
          token: token,
          loggedin: true,
          user: sessions.user,
          routers: response.data,
          routeractive: routeractive,
          notifications: { invoice: 0, info: 0 },
        };
        session.update((n) => sessionData);
        console.log(sessions);
      });
    }
  }

  let loading = false;
  $: dataFiltered = [];
  function loadData(endpoint, token, filter = false) {
    var config = {
      method: "get",
      url: endpoint,
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    AXHR(config).then(function (response) {
      let res;
      res = response.data;
      if (filter !== false) {
        res = res.filter((el) => {
          return el[filter.name] !== filter.value;
        });
      } else {
        res = res;
      }
      dataFiltered = res;
    });
  }

  let input_server_location = "Select Server";
  let inputarea_notif = true;

  $: if (sessions.routeractive) {
    input_server_location = sessions.routeractive.name;
  } else {
    input_server_location = "Select Server";
  }
  function areaUpdate(selected) {
    if (localStorage.getItem("_server_location")) {
      localStorage.setItem("_server_location", selected);
    } else {
      localStorage.setItem("_server_location", selected);
    }
    checkSessionData(sessions.token, selected);
    location.reload();
  }

  export let pingColor = "gray";
</script>

<Modal backdropClose size="lg:w-2/5 w-full z-50">
  <div class="flex w-full gap-2" slot="trigger" let:open>
    {#if inputarea_notif}
      <button
        on:click={open}
        on:click={loadData(sessions.api + "/rb", sessions.token, false)}
        class="flex items-center w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-full shadow pointer-events-auto focus:outline-none md:focus:border-gray-600"
        title={input_server_location}
      >
        <span class="flex w-6 h-6"
          ><span
            class="absolute inline-flex w-6 h-6 bg-{pingColor}-300 rounded-full opacity-75 animate-ping"
          />
          <span
            class="relative inline-flex w-6 h-6 overflow-hidden rounded-full"
            ><img src="./assets/svg/gps.svg" width="27px" alt="gps" /></span
          ></span
        >
        <div class="pr-2 font-light text-left text-gray-700 ellipsis-1">
          {input_server_location}
        </div>
      </button>
    {:else}
      <button
        on:click={open}
        class="flex items-center w-full gap-2 px-2 py-1 text-sm font-bold bg-white border border-gray-200 rounded-full shadow pointer-events-auto focus:outline-none md:focus:border-gray-600"
        title={input_server_location}
      >
        <span class="flex w-6 h-6"
          ><span class="absolute inline-flex w-6 h-6 rounded-full opacity-75" />
          <span
            class="relative inline-flex w-6 h-6 overflow-hidden rounded-full"
            ><img src="./assets/svg/gps.svg" width="27px" alt="gps" /></span
          ></span
        >
        <div class="pr-2 font-light text-left text-gray-700 ellipsis-1">
          {input_server_location}
        </div>
      </button>
    {/if}
  </div>

  <div slot="header">
    <h1 class="text-lg">Select Server</h1>
  </div>
  <div slot="content" class="h-full">
    <div class="w-full rounded-lg lg:px-2">
      {#if loading}
        <Load />
      {/if}
      <div class="flex justify-between gap-2 px-2 pb-2">
        <button
          type="button"
          class="w-full px-5 py-2 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
          on:click={(e) =>
            loadData(sessions.api + "/rb", sessions.token, false)}
        >
          Refresh
        </button>
        <a
          href="/server"
          type="button"
          class="w-full px-5 py-2 text-center text-gray-100 bg-blue-600 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
        >
          Add Server
        </a>
      </div>
      <div class="w-full h-auto pb-10">
        {#if dataFiltered}
          {#each dataFiltered as d, i}
            {#if d.disabled == "Y"}
              <div class="w-full ">
                <div
                  title="This Server Configuration Is Disabled, Please Pay to Activate"
                  class="flex items-center justify-between gap-2 px-4 py-3 m-2 text-left bg-yellow-100 rounded-md shadow cursor-not-allowed hover:bg-yellow-200 hover:shadow-outline"
                >
                  <div
                    class="flex items-center w-1/5 h-12 p-2 text-base text-gray-800 bg-white rounded-full lg:h-20 md:h-16 lg:w-3/12 md:w-3/12"
                  >
                    <img
                      alt={d.name}
                      class="w-full"
                      src="{sessions.api}/logo/{d.logo}"
                    />
                  </div>
                  <div
                    class="w-4/5 text-base text-gray-800 lg:w-7/12 md:w-7/12"
                  >
                    <b>{d.name}</b><br />
                    {d.ipAddress}
                    {#if d.updated}
                      <br />
                      <span class="text-xs text-gray-600">^up {d.updated}</span>
                    {/if}
                  </div>
                  <div
                    class="flex items-center justify-end w-1/5 gap-2 lg:w-2/12 md:w-4-12"
                  >
                    <a
                      href="/go/server"
                      class="px-2 py-1 text-xs text-white bg-blue-500 rounded-md cursor-pointer"
                      >Pay Now</a
                    >
                  </div>
                </div>
              </div>
            {:else}
              <div class="w-full ">
                <div
                  class="flex items-center justify-between gap-2 px-4 py-3 m-2 text-left bg-gray-100 rounded-md shadow cursor-pointer hover:bg-white hover:shadow-outline"
                >
                  <div
                    class="flex items-center w-1/5 h-12 p-2 text-base text-gray-800 bg-white rounded-full lg:h-20 md:h-16 lg:w-3/12 md:w-3/12"
                  >
                    <img
                      alt={d.name}
                      class="w-full"
                      src="{sessions.api}/logo/{d.logo}"
                    />
                  </div>
                  <div
                    title="Click To Connect"
                    on:click|preventDefault
                    on:click={() => areaUpdate(i)}
                    on:click={() =>
                      document.getElementsByClassName("backdrop")[0].click()}
                    class="w-4/5 text-base text-gray-800 lg:w-7/12 md:w-7/12"
                  >
                    <b>{d.name}</b><br />
                    {d.ipAddress}
                    {#if d.updated}
                      <br />
                      <span class="text-xs text-gray-600">^up {d.updated}</span>
                    {/if}
                  </div>
                  <div
                    class="flex items-center justify-end w-1/5 gap-2 lg:w-2/12 md:w-4-12"
                  >
                    {#if localStorage.getItem("_server_location")}
                      {#if sessions.routeractive.id === d.id}
                        <span
                          class="flex px-2 py-1 text-xs text-white bg-blue-600 rounded-full"
                          >Active</span
                        >
                      {/if}
                    {/if}
                  </div>
                </div>
              </div>
            {/if}
          {:else}
            <p
              class="w-full p-5 mt-10 text-center bg-yellow-100 border-2 border-yellow-200 rounded-lg"
            >
              <b class="text-2xl">Oops...<br />No server yet</b><br />You don't
              have a server to use, please add your server first to get started
            </p>
          {/each}
        {:else}
          <div class="w-full lg:w-auto">
            <div
              class="w-full p-2 mx-auto mb-2 text-xs bg-yellow-300 border-4 border-t border-b border-r border-yellow-600 border-solid rounded shadow-lg lg:w-auto color-white"
            >
              <h2 class="text-sm font-bold">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  class="inline-block w-5 h-5"
                >
                  <path
                    d="M4 8a6 6 0 0 1 4.03-5.67 2 2 0 1 1 3.95 0A6 6 0 0
                                    1 16 8v6l3 2v1H1v-1l3-2V8zm8 10a2 2 0 1 1-4 0h4z"
                  />
                </svg>
                Oops..
              </h2>
              <p>
                You don't have a linked server yet, please add your server first
              </p>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</Modal>
